import _processor from "./processor";
var exports = {};
var Processor = _processor;
exports.Processor = Processor;
export default exports;
const _Processor = exports.Processor;
export { _Processor as Processor };